import React from "react";
import { CheckSquare, ListChecks, Square, X } from "lucide-react";

// Rows the CRM tables will pull in when you ask for everything matching a filter (backend caps at this too).
export const BULK_LIMIT = 2000;

// Bulk selection bar for the CRM tables: how many are picked, one-click select-all, and the actions.
export const BulkSelectBar = ({ count, total, withEmail, noun = "contacts", allSelected, onSelectAll, onClear, onSelectMatching, matchingBusy, children, testid = "bulk-bar" }) => (
  <div className={`bulk-bar${count ? " on" : ""}`} data-testid={testid}>
    <button className="bulk-all" onClick={onSelectAll} data-testid={`${testid}-all`}>
      {allSelected ? <CheckSquare size={13} /> : <Square size={13} />}
      {allSelected ? `All ${total.toLocaleString()} selected` : `Select all ${total.toLocaleString()} ${noun}`}
    </button>
    <span className="bulk-count" data-testid={`${testid}-count`}>
      {count ? `${count.toLocaleString()} selected` : `No ${noun} selected`}
      {count && withEmail !== undefined && withEmail < count ? ` · ${withEmail.toLocaleString()} with an email` : ""}
    </span>
    {onSelectMatching ? (
      <button className="bulk-all" onClick={onSelectMatching} disabled={matchingBusy} data-testid={`${testid}-matching`}>
        <ListChecks size={13} />{matchingBusy ? "Loading…" : `Select more ${noun} matching this filter`}
      </button>
    ) : null}
    {count ? <button className="bulk-clear" onClick={onClear} data-testid={`${testid}-clear`}><X size={11} />Clear</button> : null}
    <span style={{ flex: 1 }} />
    <div className="bulk-acts">{children}</div>
  </div>
);
